const currentURL = new URL(window.location.href);
const experienceBackButton = document.querySelector('.experiences-detail__back');

experienceBackButton.addEventListener('click', (e) => {
  e.preventDefault();
  const pathname = window.location.pathname.trim().split('/');

  if (document.referrer && document.referrer !== currentURL.toString()) {
    const previousURL = new URL(document.referrer);

    if (window.location.origin === previousURL.origin
            && previousURL.pathname.includes(pathname[1])) {
      window.location.href = document.referrer;
      return false;
    }
  }
  window.location.href = `${window.location.origin}/${pathname[1]}`;
  return false;
});
